import React, { createContext, useState, useContext, useEffect } from 'react';
import { toast } from 'react-toastify';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState(() => {
    try {
      const localData = localStorage.getItem('minela-cart');
      // Eğer localData null veya tanımsızsa, veya parse edilemezse boş bir dizi döndür
      const parsedData = localData ? JSON.parse(localData) : [];
      // Ayrıca parsedData'nın gerçekten bir dizi olduğundan emin olalım
      return Array.isArray(parsedData) ? parsedData : [];
    } catch (error) {
      console.error("Sepet verileri okunurken veya ayrıştırılırken hata oluştu:", error);
      // localStorage'ı temizle ve boş dizi döndür
      localStorage.removeItem('minela-cart');
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem('minela-cart', JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (product, variant, quantity = 1) => {
    // Varyant gelmediyse güvenli varsayılan oluştur
    const safeVariant = variant || { color: 'Standart', size: 'Std', price_override: null };

    const cartId = `${product.id}-${safeVariant.color}-${safeVariant.size}`;
    const existingItem = cartItems.find((item) => item.cartId === cartId);

    if (existingItem) {
      setCartItems(
        cartItems.map((item) =>
          item.cartId === cartId
            ? { ...item, quantity: item.quantity + quantity }
            : item
        )
      );
      toast.info(`${product.name} ürününün miktarı artırıldı.`);
    } else {
      // Ürün bilgilerini tam olarak kopyala (category alanı dahil)
      const effectivePrice = typeof product.price === 'number' ? product.price : parseFloat(product.price) || 0;
      const cartItem = {
        ...product,
        variant: safeVariant,
        quantity,
        cartId,
        // Önemli alanları açıkça kopyala
        id: product.id,
        name: product.name,
        price: effectivePrice,
        category: product.category, // Kategori alanını açıkça ekle
        main_image_url: product.main_image_url
      };
      setCartItems([...cartItems, cartItem]);
      toast.success(`${product.name} sepete eklendi!`);
    }
  };

  const removeFromCart = (cartId) => {
    const itemToRemove = cartItems.find(item => item.cartId === cartId);
    setCartItems(cartItems.filter(item => item.cartId !== cartId));
    if (itemToRemove) {
      toast.error(`${itemToRemove.name} sepetten çıkarıldı.`);
    }
  };

  const updateQuantity = (cartId, newQuantity) => {
    if (newQuantity < 1) {
      removeFromCart(cartId);
      return;
    }
    setCartItems(cartItems.map(item => item.cartId === cartId ? { ...item, quantity: newQuantity } : item));
  };

  const clearCart = () => {
    setCartItems([]);
  };

  const cartItemCount = cartItems.reduce((acc, item) => acc + item.quantity, 0);

  const value = {
    cartItems,
    addToCart,
    removeFromCart,
    updateQuantity,
    cartItemCount,
    clearCart,
  };

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};